const DEFAULT_OPTIONS = {
    query: 'q',
    redirect: '',
    separator: '?'
};

class InlineSearch {
    constructor($el, options) {
        options = { ...DEFAULT_OPTIONS, ...options };

        this.$el = $el;

        this.$form = this.$el.find('[data-control="form"]');
        this.$input = this.$el.find('[data-control="input"]');
        this.$submit = this.$el.find('[data-control="submit"]');

        Object.assign(this, options);

        this.init();
    }

    init() {
        this.setupListeners();
    }

    onSearchClick(evt) {
        evt.preventDefault();

        if(this.$input.val()) {
            this.onSearchSubmit();
        } else {
            this.$input.get(0).focus();
        }
    }

    onSearchSubmit(evt) {
        evt?.preventDefault();

        const value = this.$input.val();
        if(!value) return;

        location.href = `${this.redirect}${this.separator}${this.query}=${value}`;
    }

    setupListeners() {
        this.$form.on('submit', (evt) => this.onSearchSubmit(evt));
        this.$submit.on('click', (evt) => this.onSearchClick(evt));
    }
}

$(() => {
    const rootEls = document.querySelectorAll('.js-inline-search');
    rootEls.forEach((el) => {
        const $el = $(el);
        
        const options = {
            query: $el.data('query') || DEFAULT_OPTIONS.query,
            redirect: $el.data('redirect') || DEFAULT_OPTIONS.redirect,
            separator: $el.data('separator') || DEFAULT_OPTIONS.separator
        };

        new InlineSearch($el, options);
    });
});
